export const environment = {
  production: true,
  apiKey: 'AIzaSyB00vpvr5a7BwQgecLmD7oyKjPKANVVkeU'
};
